import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "subtitle-1 pa-0 ma-0" },
        [
          _c("span", [
            _vm._v(
              "Unidades (" +
                _vm._s(_vm.value.unidades.length) +
                " selecionada(s))"
            ),
          ]),
          _c(VSwitch, {
            staticClass: "ml-4",
            attrs: { color: "secondary", dense: "" },
            model: {
              value: _vm.value.habilitado,
              callback: function ($$v) {
                _vm.$set(_vm.value, "habilitado", $$v)
              },
              expression: "value.habilitado",
            },
          }),
        ],
        1
      ),
      _c(
        VCardText,
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.habilitado,
              expression: "value.habilitado",
            },
          ],
          staticClass: "pa-0 ma-0",
        },
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("app-treeview", {
                    key: _vm.value.macro,
                    attrs: {
                      value: _vm.treeview,
                      nos: _vm.unidadesMacro,
                      lista: _vm.unidades,
                    },
                    on: { return: (value) => _vm.sincronize(value) },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("children"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }